import React from "react";
import PropTypes from "prop-types";
import { scrollToElement } from "@website-builder/utilities-index";
import { Link } from "gatsby";

import { getSegmentAnonymousId } from "@website-builder/utilities-index";
import { getVwoCampaignId } from "@website-builder/utilities-index";
import { getGclid } from "@website-builder/utilities-index";
import { GetReferrer } from "@website-builder/utilities-index";
import { GetReferrerUtmParams } from "@website-builder/utilities-index";

const AElement = (props) => React.createElement("a", props);

const CtaLink = (props) => {
	const { type, value, target, className, children } = props;

	const getTypeFormURLWithParameters = (value) => {
		const campaignVariationIdStr = getVwoCampaignId();
		const [referral, referral2] = GetReferrer();
		const referrerUtmParams = GetReferrerUtmParams();
		const gclid = getGclid();
		const params = new URLSearchParams({
			referral,
			referral2,
			segmentanonymousid: getSegmentAnonymousId(),
			...(campaignVariationIdStr && { variationid: campaignVariationIdStr }),
			...(gclid && { gclid }),
			...referrerUtmParams,
		}).toString();
		let typeformUrl = `${value}?&${params}`;
		window.open(typeformUrl, target ? target : "_blank");
	};

	if (type === "hash") {
		return (
			<AElement className={className} onClick={() => scrollToElement(value)}>
				{children}
			</AElement>
		);
	}
	if (type === "typeform") {
		return (
			<AElement
				className={className}
				href="#"
				onClick={() => getTypeFormURLWithParameters(value)}
				target={target}
			>
				{children}
			</AElement>
		);
	}

	if (type === "external") {
		return (
			<AElement className={className} href={value} target={target}>
				{children}
			</AElement>
		);
	}

	if (type === "internal") {
		return (
			<AElement className={className} href={value} target="_self">
				{children}
			</AElement>
		);
	}
};

CtaLink.propTypes = {
	type: PropTypes.oneOf(["hash", "external", "internal", "typeform"]),
	value: PropTypes.string,
	className: PropTypes.string,
	pathName: PropTypes.string,
	target: PropTypes.oneOf(["_blank", "_self"]),
};

CtaLink.defaultProps = {
	className: "",
	type: "hash",
	value: "",
	pathName: "",
	Link: Link,
	target: "_blank",
};

export default CtaLink;
